// gameEngineRegistry.ts
import type { GameEngine } from './game-engine-helper';

let currentEngine: GameEngine | undefined;

export function registerGameEngine(engine: GameEngine) {
    currentEngine = engine;
}

export function unregisterGameEngine(engine: GameEngine) {
    if (currentEngine === engine) {
        currentEngine = undefined;
    }
}

export function getCurrentGameEngine(): GameEngine | undefined {
    return currentEngine;
}
